// Copy per arricchire il report dell'archetipo dopo il test.

export const DIM_WHY = {
  direzione: "La Direzione è la tua bussola: senza priorità chiare l'energia si disperde in mille rivoli. È qui che il test ha individuato il tuo margine di crescita più grande.",
  continuita: "La Continuità è ciò che trasforma le buone intenzioni in risultati reali. Il test mostra che è l'area su cui conviene concentrarsi adesso.",
  spazio: "Lo Spazio è il confine che protegge il tuo tempo e la tua attenzione. È emerso come l'area oggi più fragile.",
  ricarica: "La Ricarica è la benzina di tutto il resto: senza energia ogni obiettivo pesa il doppio. Il test segnala che le tue riserve meritano attenzione.",
  motivazione: "La Motivazione è il 'perché' che ti spinge ad agire ogni giorno. È l'area in cui il test ha rilevato più spazio per riaccendere lo slancio.",
  mentalita: "La Mentalità è il dialogo interno che colora ogni tua scelta. È qui che il test ha visto il margine più grande per lavorare su di te.",
};

export const LEVEL_EXPECT = {
  ripartire: "Partiamo dalle fondamenta: micro-passi semplici e sostenibili per rimettere in moto la tua area di focus, senza pressione e senza sensi di colpa.",
  stabilizzare: "Consolidiamo ciò che già funziona: rendiamo stabile e quasi automatico ciò che oggi dipende ancora dall'umore o dalle circostanze.",
  potenziare: "Alziamo l'asticella: tecniche più avanzate per portare una tua forza già presente a un livello superiore.",
};

export const WEEK_PLAN = [
  ["Consapevolezza", "Fai il punto sul tuo vero punto di partenza."],
  ["Primo passo", "Introduci un cambiamento piccolo ma concreto."],
  ["Lettura guidata", "Approfondisci con una lettura pensata per te."],
  ["Rinforzo", "Rendi più solida la nuova abitudine."],
  ["Ostacolo", "Impari a superare la prima resistenza."],
  ["Seconda lettura", "Vai più a fondo con un nuovo spunto."],
  ["Esercizio finale", "Tiri le fila e porti con te ciò che conta."],
];
